import React from "react";
import { useStore } from "@/store/index";
import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import styles from "../../../styles/userPage/loginSecutity.module.scss";
import { EModalAuthType, EBtnType } from "../../../models/common/enums";
import Btn from "../../common/Btn";

const LoginSecurity = () => {
    const dispatch = useStore(state => state.dispatchAuth);

    return (
        <div>
            <h2 className={styles.h2Title}>Login</h2>
            <MDBRow className={styles.rowContent}>
                <MDBCol size={6} xl={8} className="">
                    <p className={styles.title}>Password</p>

                    {/* TO DO
                    
                    <p className={styles.detail}>Last update: {lastUpdate}</p> */}
                </MDBCol>
                <MDBCol size={6} xl={4} className={styles.colContent}>
                    <Btn
                        btnType={EBtnType.TRANSPARENTBLACK}
                        onClick={async () =>
                            dispatch({
                                type: "SET_AUTH_TYPE",
                                payload: EModalAuthType.CHANGE_PASSWORD,
                            })
                        }
                    >
                        Update Password
                    </Btn>
                </MDBCol>
                <MDBCol size={12} className="mt-5">
                    <Btn
                        onClick={async () =>
                            dispatch({
                                type: "SET_AUTH_TYPE",
                                payload: EModalAuthType.DELETE_USER,
                            })
                        }
                    >
                        Delete Account
                    </Btn>
                </MDBCol>
            </MDBRow>
        </div>
    );
};

export default LoginSecurity;
